import { CcatPathType, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '../../models';
import { LocDisplayType } from '../../models/display-type';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|CcatPathType|`;

type SharedKeys = Pick<LocDef, 'portal' | 'displayType' | 'htmlAllowed' | 'shared' | 'feature'>;

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'shared' | 'feature'> = {
	displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
	htmlAllowed: false,
	shared: true,
	feature: HubFeature.Credential,
};

const sharedSpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'SP',
};

const sharedCpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'CP',
};

export type CPCcatPathTypeLocs = `CPCcatPathType${CcatPathType}`;

export type SPCcatPathTypeLocs = `SPCcatPathType${CcatPathType}`;

export const cpCcatPathTypeEnumLocs: LocDefs<CPCcatPathTypeLocs> = {
	CPCcatPathTypeOneShot: {
		defaultValue: 'One Shot',
		displayPath: `${dpRoot}${CcatPathType.OneShot}`,
		description: `System value for '${CcatPathType.OneShot}' CCAT path type`,
		legacyName: 'Credential/System.Enum.CcatPathType.OneShot',
		...sharedCpLocData,
	},
	CPCcatPathTypeOneShotExtendable: {
		defaultValue: 'One Shot Extendablee',
		displayPath: `${dpRoot}${CcatPathType.OneShotExtendable}`,
		description: `System value for '${CcatPathType.OneShotExtendable}' CCAT path type`,
		legacyName: 'Credential/System.Enum.CcatPathType.OneShotExtendable',
		...sharedCpLocData,
	},
	CPCcatPathTypeRepeatable: {
		defaultValue: 'Repeatable',
		displayPath: `${dpRoot}${CcatPathType.Repeatable}`,
		description: `System value for '${CcatPathType.Repeatable}' CCAT path type`,
		legacyName: 'Credential/System.Enum.CcatPathType.Repeatable',
		...sharedCpLocData,
	},
};

export const spCcatPathTypeEnumLocs: LocDefs<SPCcatPathTypeLocs> = {
	SPCcatPathTypeOneShot: {
		defaultValue: 'One Shot',
		displayPath: `${dpRoot}${CcatPathType.OneShot}`,
		description: `System value for '${CcatPathType.OneShot}' CCAT path type`,
		legacyName: 'Credential/System.Enum.CcatPathType.OneShot',
		...sharedSpLocData,
	},
	SPCcatPathTypeOneShotExtendable: {
		defaultValue: 'One Shot Extendablee',
		displayPath: `${dpRoot}${CcatPathType.OneShotExtendable}`,
		description: `System value for '${CcatPathType.OneShotExtendable}' CCAT path type`,
		legacyName: 'Credential/System.Enum.CcatPathType.OneShotExtendable',
		...sharedSpLocData,
	},
	SPCcatPathTypeRepeatable: {
		defaultValue: 'Repeatable',
		displayPath: `${dpRoot}${CcatPathType.Repeatable}`,
		description: `System value for '${CcatPathType.Repeatable}' CCAT path type`,
		legacyName: 'Credential/System.Enum.CcatPathType.Repeatable',
		...sharedSpLocData,
	},
};

export const CCAT_PATH_TYPE_ENUM_LOCS = MapLocKeys<CPCcatPathTypeLocs | SPCcatPathTypeLocs>({
	...cpCcatPathTypeEnumLocs,
	...spCcatPathTypeEnumLocs,
});

export type CPCcatPathTypeEnumLocType = LocMap<CPCcatPathTypeLocs>;
export type SPCcatPathTypeEnumLocType = LocMap<SPCcatPathTypeLocs>;

export const cpCcatPathTypeKeys: {
	[key in CcatPathType]: keyof CPCcatPathTypeEnumLocType;
} = {
	[CcatPathType.OneShot]: CCAT_PATH_TYPE_ENUM_LOCS.CPCcatPathTypeOneShot,
	[CcatPathType.OneShotExtendable]: CCAT_PATH_TYPE_ENUM_LOCS.CPCcatPathTypeOneShotExtendable,
	[CcatPathType.Repeatable]: CCAT_PATH_TYPE_ENUM_LOCS.CPCcatPathTypeRepeatable,
};

export const spCcatPathTypeKeys: {
	[key in CcatPathType]: keyof SPCcatPathTypeEnumLocType;
} = {
	[CcatPathType.OneShot]: CCAT_PATH_TYPE_ENUM_LOCS.SPCcatPathTypeOneShot,
	[CcatPathType.OneShotExtendable]: CCAT_PATH_TYPE_ENUM_LOCS.SPCcatPathTypeOneShotExtendable,
	[CcatPathType.Repeatable]: CCAT_PATH_TYPE_ENUM_LOCS.SPCcatPathTypeRepeatable,
};
